import { render } from "./CategoricalCause.vue?vue&type=template&id=2c6e93ae&scoped=true"
import script from "./CategoricalCause.vue?vue&type=script&lang=js"
export * from "./CategoricalCause.vue?vue&type=script&lang=js"

import "./CategoricalCause.vue?vue&type=style&index=0&id=2c6e93ae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e93ae"]])

export default __exports__